export default __webpack_public_path__ + "e868577d5512f2d1e2ba2a3aae37110e.png";